export default __webpack_public_path__ + "img/VnEKfaBD.3e45a265.svg";